import styled from 'styled-components'
import { Button } from 'reactstrap'

export const StyledExportButton = styled(Button)`
  borderradius: 0.125rem;
  margin: 0.3125rem;
`
